module.exports = __webpack_public_path__ + "img/612.fb89adec.jpg";